import React from "react";
import styled from "styled-components";

/**
 * AB Vault brand mark — ported from `apps/vault-frontend/src/components/AbLogo.tsx` (same asset,
 * `ab_logo_wht.png`, 300×97 white AB logo), copied into THIS app's own `public/assets/imgs/` rather
 * than referencing the other app's public folder (they're separate CRA builds with separate
 * `PUBLIC_URL`s at runtime).
 */
const Img = styled.img<{ $height: number }>`
  height: ${(p) => p.$height}px;
  width: auto;
  display: block;
`;

// PUBLIC_URL is "" in dev (served at /assets/...) and the deployed base path in prod — same
// resolution pattern as vault-frontend's AbLogo (see that file's doc comment).
const LOGO_SRC = `${process.env.PUBLIC_URL ?? ""}/assets/imgs/ab_logo_wht.png`;

const AbLogo = ({ height = 32 }: { height?: number }) => (
  <Img src={LOGO_SRC} alt="American Bridge Vault" $height={height} />
);

export default AbLogo;
